/* ==========================================================================
   bl-drops.js — comportamiento de la capa `bl-` del rediseño Drops 2026
   Vanilla, sin dependencias. Cada bloque se auto-inicializa y es idempotente,
   para que siga funcionando al recargar una sección en el editor de temas.
   ========================================================================== */
(function () {
  'use strict';

  var MONEY_FORMAT = (window.BLDrops && window.BLDrops.moneyFormat) || '{{amount_with_comma_separator}} €';

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return MONEY_FORMAT.replace('{{amount_with_comma_separator}}', whole + ',' + parts[1]);
  }

  /* ------------------------------------------------------------------------
     1 · Selector de planes + añadir al carrito + barra fija
     ------------------------------------------------------------------------ */
  function initBuy(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var options = Array.prototype.slice.call(root.querySelectorAll('.bld-plan'));
    if (!options.length) return;

    var variantId = root.getAttribute('data-variant-id');
    var cta = root.querySelector('[data-bld-add]');
    var ctaPrice = root.querySelector('[data-bld-cta-price]');
    var errorBox = root.querySelector('[data-bld-error]');
    var sticky = document.querySelector('[data-bld-sticky]');
    var stickyBtn = sticky ? sticky.querySelector('[data-bld-add]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-bld-sticky-price]') : null;
    var stickyCtaPrice = sticky ? sticky.querySelector('[data-bld-sticky-cta-price]') : null;
    var current = null;

    function select(option) {
      if (!option) return;
      current = option;
      options.forEach(function (o) {
        var on = o === option;
        o.classList.toggle('is-active', on);
        var input = o.querySelector('input');
        if (input) input.checked = on;
      });
      var price = option.getAttribute('data-now') || '';
      var name = option.getAttribute('data-name') || '';
      if (ctaPrice) ctaPrice.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price + (name ? ' · ' + name : '');
      if (stickyCtaPrice) stickyCtaPrice.textContent = price;
      hideError();
    }

    function byRadioValue(value) {
      for (var i = 0; i < options.length; i++) {
        var input = options[i].querySelector('input');
        if (input && input.value === value) return options[i];
      }
      return null;
    }

    /* Excepción única al arranque: que la URL pida otro plan expresamente
       (?plan=q | ?selling_plan=<id>), pensado para campañas. Un valor que no
       corresponda a ninguna opción se ignora en silencio. */
    function fromUrl() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return null;
      }
      var sellingPlan = params.get('selling_plan');
      if (sellingPlan) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].getAttribute('data-plan') === String(sellingPlan)) return options[i];
        }
      }
      var map = { q: 'q', trimestral: 'q', trio: 'q', 3: 'q', m: 'm', mensual: 'm', o: 'o', unica: 'o' };
      var wanted = map[(params.get('plan') || '').toLowerCase()];
      return wanted ? byRadioValue(wanted) : null;
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        select(option);
      });
      var input = option.querySelector('input');
      if (input) {
        /* Las flechas del teclado en un grupo de radios sólo disparan `change`. */
        input.addEventListener('change', function () {
          select(option);
        });
      }
    });

    select(fromUrl() || byRadioValue('m') || options[0]);

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.classList.add('is-on');
    }

    function hideError() {
      if (!errorBox) return;
      errorBox.classList.remove('is-on');
      errorBox.textContent = '';
    }

    function drawer() {
      return document.querySelector('cart-drawer');
    }

    function refreshDrawer() {
      return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (sections) {
          var node = drawer();
          if (node && typeof node.renderContents === 'function') {
            node.classList.remove('is-empty');
            node.renderContents({ sections: sections });
          }
          if (node && typeof node.open === 'function') {
            try {
              node.open();
            } catch (e) {
              /* el drawer decide; si no abre, el usuario tiene el icono del carrito */
            }
          }
          if (typeof window.bldRefreshCartExtras === 'function') window.bldRefreshCartExtras();
        });
    }

    function add(button) {
      if (!current || !variantId) return;
      hideError();
      var payload = { id: Number(variantId), quantity: Number(current.getAttribute('data-qty')) || 1 };
      var plan = current.getAttribute('data-plan');
      if (plan) payload.selling_plan = Number(plan);

      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [payload] })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw body;
            });
          }
          return response.json();
        })
        .then(refreshDrawer)
        .then(function () {
          button.disabled = false;
          refreshCartCount();
        })
        .catch(function (error) {
          button.disabled = false;
          showError((error && (error.description || error.message)) || root.getAttribute('data-error-text') || '');
        });
    }

    [cta, stickyBtn].forEach(function (button) {
      if (!button) return;
      button.addEventListener('click', function () {
        add(button);
      });
    });

    if (sticky && cta) {
      var syncSticky = function () {
        var box = cta.getBoundingClientRect();
        var away = box.bottom < 0 || box.top > window.innerHeight;
        sticky.classList.toggle('is-visible', away);
        sticky.setAttribute('aria-hidden', away ? 'false' : 'true');
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
  }

  /* ------------------------------------------------------------------------
     2 · Rejilla de activos con modal
     ------------------------------------------------------------------------ */
  function initIngredients(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var modal = root.querySelector('[data-bld-modal]');
    if (!modal) return;

    var elNum = modal.querySelector('[data-bld-modal-num]');
    var elImg = modal.querySelector('[data-bld-modal-img]');
    var elName = modal.querySelector('[data-bld-modal-name]');
    var elTag = modal.querySelector('[data-bld-modal-tag]');
    var elDesc = modal.querySelector('[data-bld-modal-desc]');
    var closers = modal.querySelectorAll('[data-bld-modal-close]');
    var lastFocused = null;

    function open(trigger) {
      lastFocused = trigger;
      if (elNum) elNum.textContent = trigger.getAttribute('data-num') || '';
      if (elName) elName.textContent = trigger.getAttribute('data-name') || '';
      if (elTag) elTag.textContent = trigger.getAttribute('data-tag') || '';
      if (elDesc) elDesc.textContent = trigger.getAttribute('data-desc') || '';
      if (elImg) {
        var src = trigger.getAttribute('data-img') || '';
        if (src) {
          elImg.setAttribute('src', src);
          elImg.setAttribute('alt', trigger.getAttribute('data-name') || '');
          elImg.hidden = false;
        } else {
          elImg.hidden = true;
        }
      }
      modal.hidden = false;
      document.addEventListener('keydown', onKey);
      var focusable = modal.querySelector('.bld-modal__x');
      if (focusable) focusable.focus();
    }

    function close() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastFocused) lastFocused.focus();
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-bld-ing]'), function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger);
      });
    });

    Array.prototype.forEach.call(closers, function (button) {
      button.addEventListener('click', close);
    });
  }

  /* ------------------------------------------------------------------------
     3 · Carrusel de testimonios en vídeo
     ------------------------------------------------------------------------ */
  function initUgc(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var rail = root.querySelector('[data-bld-ugc-rail]');
    var track = root.querySelector('[data-bld-ugc-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bld-ugc-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bld-ugc-dot]'));
    var prev = root.querySelector('[data-bld-ugc-prev]');
    var next = root.querySelector('[data-bld-ugc-next]');
    var hint = root.querySelector('[data-bld-ugc-hint]');
    var hintSound = root.getAttribute('data-hint-sound') || '';
    var hintMuted = root.getAttribute('data-hint-muted') || '';
    var labelWatch = root.getAttribute('data-label-watch') || '';
    var labelMute = root.getAttribute('data-label-mute') || '';
    var labelUnmute = root.getAttribute('data-label-unmute') || '';

    if (!rail || !track || !cards.length) return;

    var active = 0;
    var inView = false;
    var userMuted = false;
    var soundOn = false;

    var videos = cards.map(function (card) {
      var video = card.querySelector('video');
      if (video) {
        video.loop = true;
        video.muted = true;
        video.setAttribute('playsinline', '');
        var src = video.getAttribute('data-src');
        if (src && !video.getAttribute('src')) video.setAttribute('src', src);
      }
      return video;
    });

    var GAP = 18;

    function cardWidth() {
      return cards[0].getBoundingClientRect().width || 268;
    }

    function shift() {
      var width = cardWidth();
      var step = width + GAP;
      var total = cards.length * width + (cards.length - 1) * GAP;
      var viewport = rail.clientWidth || 0;
      if (!viewport || total <= viewport) return 0;
      var want = active * step + width / 2 - viewport / 2;
      return -Math.round(Math.min(Math.max(want, 0), total - viewport));
    }

    function paintCta(card, index) {
      var cta = card.querySelector('[data-bld-ugc-cta]');
      if (!cta) return;
      if (index !== active) cta.textContent = labelWatch;
      else cta.textContent = soundOn ? labelMute : labelUnmute;
    }

    function paint() {
      track.style.transform = 'translateX(' + shift() + 'px)';
      cards.forEach(function (card, index) {
        card.classList.toggle('is-active', index === active);
        card.classList.toggle('is-audible', index === active && soundOn);
        paintCta(card, index);
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-current', index === active ? 'true' : 'false');
      });
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === cards.length - 1;
      if (hint) hint.textContent = soundOn ? hintSound : hintMuted;
    }

    /* Intenta reproducir con audio; si el navegador bloquea el autoplay,
       cae a silencio y el hint pasa a "pulsa el vídeo para activar el sonido".

       Ningún navegador deja arrancar un vídeo con sonido antes de que el
       usuario haya interactuado con la página: el scroll NO cuenta como
       interacción. Por eso, además de intentarlo al entrar en pantalla,
       reintentamos en cuanto hay un gesto real (clic, toque o tecla) en
       cualquier punto de la página. `reload = true` fuerza pausa + play para
       que el navegador reevalúe el permiso en lugar de dejar el vídeo
       corriendo en silencio. */
    function sync(reload) {
      videos.forEach(function (video, index) {
        if (!video) return;
        if (index === active && inView) {
          var wantsSound = !userMuted;
          if (reload && wantsSound && video.muted && !video.paused) video.pause();
          video.muted = userMuted;
          var promise = video.play();
          if (promise && promise.catch) {
            promise.catch(function () {
              video.muted = true;
              if (soundOn) {
                soundOn = false;
                paint();
              }
              var retry = video.play();
              if (retry && retry.catch) retry.catch(function () {});
            });
          }
          var nowOn = !video.muted;
          if (nowOn !== soundOn) {
            soundOn = nowOn;
            paint();
          }
        } else {
          video.pause();
          video.muted = true;
          try {
            video.currentTime = 0;
          } catch (e) {
            /* algunos navegadores lo rechazan antes de tener metadatos */
          }
        }
      });
    }

    function go(index) {
      active = Math.min(Math.max(index, 0), cards.length - 1);
      paint();
      sync(true);
    }

    /* Un clic sobre la tarjeta activa silencia o activa; sobre otra, la trae
       al centro con el sonido puesto. El botón de la capa superior es un span
       dentro del propio botón de la tarjeta, así que no necesita su propio
       manejador: el clic burbujea hasta aquí igualmente. */
    function pick(index) {
      if (index === active) {
        userMuted = !userMuted;
        soundOn = !userMuted;
        paint();
        sync(true);
      } else {
        userMuted = false;
        go(index);
      }
    }

    cards.forEach(function (card, index) {
      var hit = card.querySelector('[data-bld-ugc-hit]');
      if (!hit) return;
      hit.addEventListener('click', function () {
        pick(index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        go(index);
      });
    });
    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });

    window.addEventListener('resize', paint);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visible = entries.some(function (entry) {
            return entry.isIntersecting;
          });
          if (visible !== inView) {
            inView = visible;
            sync(true);
          }
        },
        { threshold: 0.35 }
      );
      observer.observe(rail);
    } else {
      inView = true;
    }

    /* El primer gesto del usuario desbloquea el audio en la mayoría de
       navegadores: en cuanto ocurre, reintentamos el vídeo activo con sonido.
       Se escuchan varios eventos porque cada navegador cuenta uno distinto
       como «activación»: puntero en escritorio, touchend en móvil, tecla con
       teclado. Sólo se reintenta si el usuario no ha silenciado a mano. */
    var onGesture = function () {
      if (!inView || userMuted || soundOn) return;
      sync(true);
    };
    window.addEventListener('pointerdown', onGesture, { passive: true });
    window.addEventListener('touchend', onGesture, { passive: true });
    window.addEventListener('click', onGesture, true);
    window.addEventListener('keydown', onGesture);

    paint();
    sync(true);
  }

  /* ------------------------------------------------------------------------
     4 · Línea de disponibilidad: última compra, cuenta atrás de envío y pre-order
     ------------------------------------------------------------------------ */
  function initStock(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var separator = root.querySelector('.bld-stk__sep');
    var activity = root.querySelector('[data-bld-stock-act]');
    var cutoff = root.querySelector('[data-bld-stock-cutoff]');
    var isPreorder = root.getAttribute('data-pre') === '1';

    function label(name) {
      return root.getAttribute(name) || '';
    }

    /* Pre-order: el CTA pasa a «reservar» en la ficha y en la barra fija. */
    if (isPreorder) {
      var preLabel = label('data-preorder-cta');
      if (preLabel) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-bld-add]'), function (button) {
          var price = button.querySelector('[data-bld-cta-price]');
          button.textContent = preLabel;
          if (price) {
            button.appendChild(document.createTextNode(' — '));
            button.appendChild(price);
          }
        });
      }
      if (separator && activity) {
        separator.hidden = false;
        activity.hidden = false;
        activity.textContent = label('data-preorder-tag');
      }
      return;
    }

    /* Contador de «última compra hace X», sobre el metafield real. */
    var stamp = parseInt(root.getAttribute('data-last'), 10);
    var windowSeconds = (parseInt(root.getAttribute('data-window'), 10) || 72) * 3600;

    function ago(seconds) {
      var minutes = Math.floor(seconds / 60);
      if (minutes < 1) return label('data-time-now');
      if (minutes < 60) return label('data-time-min').replace('[m]', minutes);
      var hours = Math.floor(minutes / 60);
      var rest = minutes % 60;
      if (!rest) return label('data-time-hour').replace('[h]', hours);
      return label('data-time-hour-min').replace('[h]', hours).replace('[m]', rest);
    }

    function tickActivity() {
      if (!stamp || !separator || !activity) return;
      var elapsed = Math.floor(Date.now() / 1000) - stamp;
      var show = elapsed >= 0 && elapsed <= windowSeconds;
      separator.hidden = !show;
      activity.hidden = !show;
      if (show) activity.textContent = label('data-last-prefix') + ago(elapsed);
    }

    /* Cuenta atrás real hasta la hora de corte de envío. */
    var cutoffOn = root.getAttribute('data-cutoff-on') === '1';
    var state = root.getAttribute('data-cutoff-state');
    var left = parseInt(root.getAttribute('data-cutoff-left'), 10) || 0;
    var start = Date.now();

    function countdown(seconds) {
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      if (hours > 0) return hours + ' h ' + minutes + ' min';
      if (minutes > 0) return minutes + ' min';
      return Math.max(0, seconds) + ' s';
    }

    function tickCutoff() {
      if (!cutoff || !cutoffOn) return;
      if (state === 'weekend') {
        cutoff.textContent = label('data-cutoff-weekend');
        return;
      }
      var remaining = left - Math.floor((Date.now() - start) / 1000);
      if (state === 'closed' || remaining <= 0) {
        cutoff.textContent = label('data-cutoff-closed');
        return;
      }
      cutoff.textContent = label('data-cutoff-text').replace('[tiempo]', countdown(remaining));
    }

    tickActivity();
    tickCutoff();
    setInterval(tickActivity, 60000);
    setInterval(tickCutoff, 1000);
  }

  /* ------------------------------------------------------------------------
     5 · Cabecera: menú lateral y contador del carrito
     ------------------------------------------------------------------------ */
  function refreshCartCount() {
    var badges = document.querySelectorAll('[data-bld-cart-count]');
    if (!badges.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        Array.prototype.forEach.call(badges, function (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {
        /* el contador se queda como estaba; no es crítico */
      });
  }

  function initHeader(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var menu = root.querySelector('[data-bld-menu]');
    var openers = root.querySelectorAll('[data-bld-menu-open]');
    var closers = root.querySelectorAll('[data-bld-menu-close]');
    var lastFocused = null;

    function setOpen(open) {
      if (!menu) return;
      menu.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
      Array.prototype.forEach.call(openers, function (button) {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (open) {
        lastFocused = document.activeElement;
        var first = menu.querySelector('.bld-menu__x');
        if (first) first.focus();
        document.addEventListener('keydown', onKey);
      } else {
        document.removeEventListener('keydown', onKey);
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }
    }

    function onKey(event) {
      if (event.key === 'Escape') setOpen(false);
    }

    Array.prototype.forEach.call(openers, function (button) {
      button.addEventListener('click', function () {
        setOpen(true);
      });
    });
    Array.prototype.forEach.call(closers, function (button) {
      button.addEventListener('click', function () {
        setOpen(false);
      });
    });

    /* Contador: se actualiza con nuestras altas y con las de Dawn (pubsub). */
    Array.prototype.forEach.call(root.querySelectorAll('[data-bld-cart-count]'), function (badge) {
      badge.hidden = badge.textContent.trim() === '0';
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
    }
  }

  /* ------------------------------------------------------------------------
     9 · Carruseles por scroll nativo (galería de la PDP)
     El arrastre lo hace el navegador con scroll-snap; las flechas sólo empujan
     una diapositiva y se desactivan al llegar a los topes.
     ------------------------------------------------------------------------ */
  function initScroller(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var track = root.querySelector('[data-bld-scroll-track]');
    var dotsBox = root.querySelector('[data-bld-scroll-dots]');
    var counter = root.querySelector('[data-bld-scroll-count]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function stepSize() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }

    /* Un punto por diapositiva, como en un carrusel de Instagram. Nada de flechas:
       el gesto es arrastrar, y los puntos dan el estado y una alternativa clicable
       para quien no tenga pantalla táctil. */
    var dots = [];
    if (dotsBox && slides.length > 1) {
      var label = dotsBox.getAttribute('data-dot-label') || '';
      dotsBox.textContent = '';
      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bld-gal__dot';
        dot.setAttribute('aria-label', (label + ' ' + (index + 1)).trim());
        dot.addEventListener('click', function () {
          track.scrollTo({ left: index * stepSize(), behavior: 'smooth' });
        });
        dotsBox.appendChild(dot);
        dots.push(dot);
      });
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      root.classList.toggle('is-static', max <= 0);
      var index = Math.round(track.scrollLeft / (stepSize() || 1));
      index = Math.max(0, Math.min(slides.length - 1, index));
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      if (counter) {
        var format = counter.getAttribute('data-count-format') || '[n] / [t]';
        counter.textContent = format.replace('[n]', index + 1).replace('[t]', slides.length);
      }
      if (!dots.length) return;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function current() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (stepSize() || 1))));
    }

    function go(direction) {
      var next = Math.max(0, Math.min(slides.length - 1, current() + direction));
      track.scrollTo({ left: next * stepSize(), behavior: 'smooth' });
    }

    /* Toque a los lados para pasar, como en Instagram. Se escucha en la propia pista
       en vez de superponer botones: un botón encima capturaría el gesto táctil y
       mataría el arrastre. Si entre pulsar y soltar el dedo se ha movido, era un
       arrastre y no se hace nada. */
    var downX = null;
    track.addEventListener(
      'pointerdown',
      function (event) {
        downX = event.clientX;
      },
      { passive: true }
    );

    track.addEventListener('click', function (event) {
      if (downX !== null && Math.abs(event.clientX - downX) > 8) return;
      var box = track.getBoundingClientRect();
      var x = event.clientX - box.left;
      var zone = box.width * 0.32;
      if (x < zone) go(-1);
      else if (x > box.width - zone) go(1);
    });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
    });

    /* Empujoncito de bienvenida: la primera vez que el carrusel entra en pantalla se
       desplaza un poco y vuelve. Es la señal que hace que la gente pruebe a deslizar;
       el borde cortado solo no siempre basta. Se hace una vez y se respeta
       `prefers-reduced-motion`. */
    function nudge() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (track.scrollWidth - track.clientWidth <= 0) return;
      if (track.scrollLeft > 4) return;
      track.scrollTo({ left: 46, behavior: 'smooth' });
      setTimeout(function () {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }, 520);
    }

    if ('IntersectionObserver' in window) {
      var seen = false;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || seen) return;
            seen = true;
            setTimeout(nudge, 500);
          });
        },
        { threshold: 0.6 }
      );
      observer.observe(root);
    }

    /* Sin `requestAnimationFrame` a propósito: con la ventana en segundo plano el
       navegador no lo dispara y un flag de throttling se quedaría colgado para
       siempre, dejando los puntos congelados. `sync()` son cuatro lecturas y un
       toggle de clase sobre un puñado de puntos: no necesita throttling. */
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------------------------------
     8 · Extras del cajón del carrito: barra de envío gratis y upsell
     El cajón es de Dawn y no se toca. Aquí se inyectan los dos bloques en su pie
     y se repintan cada vez que cambia el carrito.
     ------------------------------------------------------------------------ */
  function initCartExtras(config) {
    if (!config || config.dataset.bldReady === '1') return;
    config.dataset.bldReady = '1';

    var threshold = parseInt(config.getAttribute('data-threshold'), 10) || 0;
    var showShip = config.getAttribute('data-show-ship') === '1' && threshold > 0;
    var showUpsell = config.getAttribute('data-show-upsell') === '1';

    function attr(name) {
      return config.getAttribute(name) || '';
    }

    function footer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return null;
      return (
        drawer.querySelector('.drawer__footer') ||
        drawer.querySelector('.cart-drawer__footer') ||
        drawer.querySelector('.drawer__inner')
      );
    }

    function render(cart) {
      var host = footer();
      if (!host) return;

      var box = host.querySelector('[data-bld-cart-extras-ui]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'bld bld-cartx';
        box.setAttribute('data-bld-cart-extras-ui', '');
        host.insertBefore(box, host.firstChild);
      }
      box.textContent = '';

      if (!cart || !cart.item_count) return;

      if (showShip) {
        var left = Math.max(0, threshold - cart.total_price);
        var bar = document.createElement('div');
        bar.className = 'bld-cartx__ship';

        var label = document.createElement('span');
        label.className = 'bld-cartx__ship-label';
        label.textContent = left > 0 ? attr('data-ship-progress').replace('[x]', money(left)) : attr('data-ship-done');
        bar.appendChild(label);

        var track = document.createElement('span');
        track.className = 'bld-cartx__track';
        var fill = document.createElement('span');
        fill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
        track.appendChild(fill);
        bar.appendChild(track);

        box.appendChild(bar);
      }

      if (showUpsell) {
        var match = attr('data-upsell-match').toLowerCase();
        var hit = !match
          ? true
          : cart.items.some(function (item) {
              var plan =
                item.selling_plan_allocation &&
                item.selling_plan_allocation.selling_plan &&
                item.selling_plan_allocation.selling_plan.name;
              return plan ? plan.toLowerCase().indexOf(match) > -1 : false;
            });

        if (hit && attr('data-upsell-title')) {
          var card = document.createElement('div');
          card.className = 'bld-cartx__upsell';

          var title = document.createElement('strong');
          title.textContent = attr('data-upsell-title');
          card.appendChild(title);

          if (attr('data-upsell-text')) {
            var text = document.createElement('p');
            text.textContent = attr('data-upsell-text');
            card.appendChild(text);
          }

          if (attr('data-upsell-cta') && attr('data-upsell-url')) {
            var link = document.createElement('a');
            link.className = 'bld-btn bld-btn--ghost bld-btn--block';
            link.href = attr('data-upsell-url');
            link.textContent = attr('data-upsell-cta');
            card.appendChild(link);
          }

          box.appendChild(card);
        }
      }
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(render)
        .catch(function () {});
    }

    refresh();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    /* Dawn repinta el cajón entero al añadir: hay que volver a inyectar. */
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-bld-add], cart-drawer')) {
        setTimeout(refresh, 900);
      }
    });
    window.bldRefreshCartExtras = refresh;
  }

  /* ------------------------------------------------------------------------
     7 · Test «¿Necesitas Drops?» con lógica ramificada
     Las preguntas, los perfiles y las recomendaciones vienen del schema; aquí
     sólo se recorre el árbol y se compone el resultado.
     ------------------------------------------------------------------------ */
  function initQuiz(root) {
    if (!root || root.dataset.bldReady === '1') return;
    root.dataset.bldReady = '1';

    var raw = root.querySelector('[data-bld-quiz-data]');
    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw.textContent);
    } catch (e) {
      return;
    }
    if (!data.questions || !data.questions.length) return;

    var panels = {
      intro: root.querySelector('[data-bld-quiz-intro]'),
      run: root.querySelector('[data-bld-quiz-run]'),
      done: root.querySelector('[data-bld-quiz-done]')
    };
    var counter = root.querySelector('[data-bld-quiz-counter]');
    var progress = root.querySelector('[data-bld-quiz-progress]');
    var title = root.querySelector('[data-bld-quiz-title]');
    var sub = root.querySelector('[data-bld-quiz-sub]');
    var options = root.querySelector('[data-bld-quiz-options]');
    var resultTitle = root.querySelector('[data-bld-quiz-result-title]');
    var resultBody = root.querySelector('[data-bld-quiz-result-body]');
    var points = root.querySelector('[data-bld-quiz-points]');

    var answers = {};
    var step = 0;

    function values(list) {
      return String(list || '')
        .split(',')
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }

    function matches(key, list) {
      if (!key) return true;
      var wanted = values(list);
      if (!wanted.length) return true;
      return wanted.indexOf(answers[key]) > -1;
    }

    /* El recorrido se recalcula en cada paso: cambiar una respuesta cambia
       qué preguntas de profundidad entran. */
    function flow() {
      return data.questions.filter(function (question) {
        return matches(question.showIfKey, question.showIfValues);
      });
    }

    function show(stage) {
      Object.keys(panels).forEach(function (key) {
        if (panels[key]) panels[key].hidden = key !== stage;
      });
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start' });
    }

    function renderQuestion() {
      var list = flow();
      if (step >= list.length) return finish();
      var question = list[step];

      if (counter) {
        counter.textContent = String(data.counter || '')
          .replace('[n]', step + 1)
          .replace('[t]', list.length);
      }
      if (progress) progress.style.width = Math.round((step / list.length) * 100) + '%';
      if (title) title.textContent = question.title || '';
      if (sub) {
        sub.textContent = question.sub || '';
        sub.hidden = !question.sub;
      }

      if (options) {
        options.textContent = '';
        (question.options || []).forEach(function (option) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'bld-quiz__option';

          var label = document.createElement('strong');
          label.textContent = option.label || '';
          button.appendChild(label);

          if (option.hint) {
            var hint = document.createElement('span');
            hint.textContent = option.hint;
            button.appendChild(hint);
          }

          button.addEventListener('click', function () {
            answers[question.id] = option.value || option.label;
            step += 1;
            if (step >= flow().length) finish();
            else renderQuestion();
          });
          options.appendChild(button);
        });
      }

      show('run');
    }

    function result() {
      var profile = null;
      for (var i = 0; i < (data.profiles || []).length; i++) {
        var candidate = data.profiles[i];
        if (candidate.whenKey && matches(candidate.whenKey, candidate.whenValues)) {
          profile = candidate;
          break;
        }
      }

      var texts = (data.rules || [])
        .filter(function (rule) {
          return rule.whenKey && matches(rule.whenKey, rule.whenValues);
        })
        .map(function (rule) {
          return rule.text;
        });

      texts = texts.concat(data.always || []);

      return {
        title: (profile && profile.title) || data.fallbackTitle || '',
        body: (profile && profile.body) || data.fallbackBody || '',
        points: texts.filter(Boolean).slice(0, data.maxPoints || 6)
      };
    }

    function finish() {
      var out = result();
      if (resultTitle) resultTitle.textContent = out.title;
      if (resultBody) {
        resultBody.textContent = out.body;
        resultBody.hidden = !out.body;
      }
      if (points) {
        points.textContent = '';
        out.points.forEach(function (text) {
          var row = document.createElement('span');
          row.className = 'bld-quiz__point';

          var tick = document.createElement('b');
          tick.setAttribute('aria-hidden', 'true');
          tick.textContent = '✓';
          row.appendChild(tick);

          var copy = document.createElement('span');
          copy.textContent = text;
          row.appendChild(copy);

          points.appendChild(row);
        });
      }
      show('done');
    }

    var start = root.querySelector('[data-bld-quiz-start]');
    if (start) {
      start.addEventListener('click', function () {
        answers = {};
        step = 0;
        renderQuestion();
      });
    }

    var back = root.querySelector('[data-bld-quiz-back]');
    if (back) {
      back.addEventListener('click', function () {
        if (step === 0) show('intro');
        else {
          step -= 1;
          renderQuestion();
        }
      });
    }

    var restart = root.querySelector('[data-bld-quiz-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        answers = {};
        step = 0;
        show('intro');
      });
    }

    /* Si el formulario de email se envió, Shopify recarga la página: se vuelve
       al resultado en vez de a la intro para no perder al usuario. */
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      show('done');
    }
  }

  /* ------------------------------------------------------------------------
     6 · Vídeos decorativos en bucle (portada)
     Con el atributo `autoplay` solo no siempre arrancan: según el momento en que
     el navegador tenga los metadatos, la promesa de play() se rechaza en silencio.
     ------------------------------------------------------------------------ */
  function initAutoplay(video) {
    if (!video || video.dataset.bldReady === '1') return;
    video.dataset.bldReady = '1';
    video.muted = true;
    video.loop = true;
    video.setAttribute('playsinline', '');

    var play = function () {
      if (document.visibilityState === 'hidden') return;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    };

    /* El navegador bloquea la reproducción mientras la pestaña o la ventana están
       ocultas, y `play()` resuelve sin error dejando el vídeo en pausa. Por eso no
       basta con un intento: se reintenta al volver a ser visible y al entrar en
       pantalla, y se pausa al salir para no gastar batería. */
    play();
    video.addEventListener('loadeddata', play);
    video.addEventListener('canplay', play);
    document.addEventListener('visibilitychange', play);
    window.addEventListener('pointerdown', play, { once: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) play();
            else video.pause();
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(video);
    }
  }

  /* ------------------------------------------------------------------------
     Arranque
     ------------------------------------------------------------------------ */
  function boot(scope) {
    var context = scope || document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-autoplay]'), initAutoplay);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-header]'), initHeader);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-buy]'), initBuy);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-stock]'), initStock);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-ingredients]'), initIngredients);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-ugc]'), initUgc);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-quiz]'), initQuiz);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-cart-extras]'), initCartExtras);
    Array.prototype.forEach.call(context.querySelectorAll('[data-bld-scroller]'), initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  /* El editor de temas recarga secciones sueltas: hay que reenganchar. */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
